var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ViewOrderDetails',{attrs:{"orderId":_vm.orderId,"supplierId":_vm.supplierId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }